import {StatusMessages} from './statusMessages.jsx';
import {parseDateString} from './date';
import {isValid, format} from 'date-fns';

const SOURCES_TO_STRING_VALUE = {
    'psl': 'PSL',
    'popup': 'Non-PSL (Describe Your Need)',
    'sourcingevent': 'Sourcing Event (Agency Mania)',
    'agency mania': 'Sourcing Event (Agency Mania)',
    'tsf': 'Sourcing Event (TSF)',
    'psl / non-psl': 'PSL / Non-PSL',
    'candex': 'Candex',
    'punchout': 'PunchOut Catalog',
    'promo': 'Nestlé Supplier Catalog',
    'nestbuy': 'NestBuy Catalog',
};

export const SOURCES = {
    PSL: 'PSL',
    AGENCY_MANIA: 'Agency Mania',
    TSF: 'TSF',
    DYN: 'popup',
    MIXED: 'PSL / Non-PSL',
    CANDEX: 'Candex',
    PUNCHOUT: 'punchout',
    PROMO: 'Promo',
    NESTBUY: 'NestBuy',
};

export const SOURCES_TO_DISPLAY = {
    PUNCHOUT: 'PunchOut Catalog',
    FAIRMARKIT: 'Sourcing Event (Fairmarkit)',
    NESTLE_SUPPLIER_CATALOGUE: 'NSC',
};

export const REQUEST_STATUSES = {
    CREATED: 'created',
    INCOMPLETE_REQUESTER_AND_SPENDER: 'incomplete - requester and spender',
    INCOMPLETE_SPENDER: 'incomplete - spender',
    INCOMPLETE_REQUESTER: 'incomplete - requester',
    SAVED: 'saved',
    DENIED_BY_REQUESTER: 'denied by requester',
    DENIED_BY_SB: 'denied by sb',
    DENIED_BY_OB: 'denied by ob',
    PENDING_REQUESTER_AND_SPENDER_COMPLETION: 'pending requester and spender completion',
    PENDING_SPENDER_COMPLETION: 'pending spender completion',
    PENDING_REQUESTER_COMPLETION: 'pending requester completion',
    PENDING_REQUESTER_COMPLETION_SAVED: 'pending requester complete',
    PENDING_SB_APPROVAL: 'pending sb approval',
    PENDING_OB_APPROVAL: 'pending ob approval',
    SUBMITTED: 'submitted',
};

export const STATUSES_TO_STRING_VALUE = {
    [REQUEST_STATUSES.CREATED]: 'New',
    [REQUEST_STATUSES.INCOMPLETE_REQUESTER_AND_SPENDER]: 'Composing - Incomplete Requester and Spender',
    [REQUEST_STATUSES.INCOMPLETE_SPENDER]: 'Composing - Incomplete Spender',
    [REQUEST_STATUSES.INCOMPLETE_REQUESTER]: 'Composing - Incomplete Requester',
    [REQUEST_STATUSES.SAVED]: 'Composing - Complete Requester and Spender',
    [REQUEST_STATUSES.DENIED_BY_REQUESTER]: 'Rejected by Requester - to review',
    [REQUEST_STATUSES.DENIED_BY_SB]: 'Rejected by Strategic Buyer - to review',
    [REQUEST_STATUSES.DENIED_BY_OB]: 'Rejected by Operational Buyer - to review',
    [REQUEST_STATUSES.PENDING_REQUESTER_AND_SPENDER_COMPLETION]: 'Pending for Requester completion - Incomplete Requester and Spender',
    [REQUEST_STATUSES.PENDING_SPENDER_COMPLETION]: 'Pending for Requester completion - Incomplete Spender',
    [REQUEST_STATUSES.PENDING_REQUESTER_COMPLETION]: 'Pending for Requester completion - Incomplete Requester',
    [REQUEST_STATUSES.PENDING_REQUESTER_COMPLETION_SAVED]: 'Pending for Requester completion - Complete Requester and Spender',
    [REQUEST_STATUSES.PENDING_SB_APPROVAL]: 'On Hold - Pending for Strategic buyer review',
    [REQUEST_STATUSES.PENDING_OB_APPROVAL]: 'On Hold - Pending for Operational buyer review',
    [REQUEST_STATUSES.SUBMITTED]: 'Submitted in SAP',
};

const STATUSES_TO_TOOLTIP_TITLE = {
    [REQUEST_STATUSES.CREATED]: StatusMessages.created,
    [REQUEST_STATUSES.INCOMPLETE_REQUESTER_AND_SPENDER]: StatusMessages.incompleteRequesterAndSpender,
    [REQUEST_STATUSES.INCOMPLETE_SPENDER]: StatusMessages.incompleteSpender,
    [REQUEST_STATUSES.INCOMPLETE_REQUESTER]: StatusMessages.incompleteRequester,
    [REQUEST_STATUSES.SAVED]: StatusMessages.saved,
    [REQUEST_STATUSES.DENIED_BY_REQUESTER]: StatusMessages.deniedByRequester,
    [REQUEST_STATUSES.DENIED_BY_SB]: StatusMessages.deniedBySB,
    [REQUEST_STATUSES.DENIED_BY_OB]: StatusMessages.deniedByOb,
    [REQUEST_STATUSES.PENDING_REQUESTER_AND_SPENDER_COMPLETION]: StatusMessages.pendingRequesterAndSpenderCompletion,
    [REQUEST_STATUSES.PENDING_SPENDER_COMPLETION]: StatusMessages.pendingSpenderCompletion,
    [REQUEST_STATUSES.PENDING_REQUESTER_COMPLETION]: StatusMessages.pendingRequesterCompletion,
    [REQUEST_STATUSES.PENDING_REQUESTER_COMPLETION_SAVED]: StatusMessages.pendingRequesterCompletionSaved,
    [REQUEST_STATUSES.PENDING_SB_APPROVAL]: StatusMessages.pendingSBApproval,
    [REQUEST_STATUSES.PENDING_OB_APPROVAL]: StatusMessages.pendingOBApproval,
    [REQUEST_STATUSES.SUBMITTED]: StatusMessages.submitted,
};

export const STATUS_GROUPS = {
    COMPOSING: {
        label: 'Composing',
        statuses: [
            REQUEST_STATUSES.INCOMPLETE_REQUESTER_AND_SPENDER,
            REQUEST_STATUSES.INCOMPLETE_SPENDER,
            REQUEST_STATUSES.INCOMPLETE_REQUESTER,
            REQUEST_STATUSES.SAVED,
        ],
    },
    REJECTED: {
        label: 'Rejected',
        statuses: [
            REQUEST_STATUSES.DENIED_BY_REQUESTER,
            REQUEST_STATUSES.DENIED_BY_SB,
            REQUEST_STATUSES.DENIED_BY_OB,
        ],
    },
    PENDING: {
        label: 'Pending',
        statuses: [
            REQUEST_STATUSES.PENDING_REQUESTER_AND_SPENDER_COMPLETION,
            REQUEST_STATUSES.PENDING_SPENDER_COMPLETION,
            REQUEST_STATUSES.PENDING_REQUESTER_COMPLETION,
            REQUEST_STATUSES.PENDING_REQUESTER_COMPLETION_SAVED,
            REQUEST_STATUSES.PENDING_SB_APPROVAL,
            REQUEST_STATUSES.PENDING_OB_APPROVAL,
        ],
    },
};

export const LAMBDA_NAMES = {
    SAVE: 'Save',
    COPY: 'Copy',
    DELETE_PR: 'Delete PR',
    CHANGE_TAB: 'Change tab',
    GET_MASTER_DATA: 'Get Master Data',
    GET_SUPPLIERS: 'Get Suppliers',
    GET_SUPPLIERS_CODE_OR_NAME: 'Get Suppliers - Code or Name',
    GET_DEFAULT_PAYMENT_TERMS: 'Get default Payment Terms',
    GET_P2P_OUTPUT_DATA: 'Get P2P Output Data',
    GET_VENDOR_EMAILS: 'Get Vendor Emails',
    GET_ADDRESS_FROM_PLANT: 'Get Address from Plant',
    GET_ADDRESS_FROM_STORAGE_LOCATION: 'Get Address from Storage Location',
    GET_PARTNER_FUNCTION: 'Get Partner Function',
    GET_ZSIM_MATERIAL_FROM_ANOTHER_BY_L3_CAT: 'Get ZSIM Material from another (by L3 Cat.)',
    SHOW_POPUP: 'Show Popup',
    GET_ERS_AND_GR: 'Get ERS and GR',
    GET_CURRENCY_EXCHANGE_RATE: 'Get currency exchange rate',
    GET_USER_INFO_BY_USER_ID: 'Get User info by User ID',
    GET_CHANGE_LOG: 'Get Change log',
    SET_TO_CHANGE_LOG: 'Set To Change Log',
    GET_CURRENCY_BY_COMPANY_CODE: 'Get Currency By Company Code',
    GET_USER_DEFAULT_INFO: 'Get User Default Info',
    GET_EMAIL_BY_GROUPING_NAME: 'Get Email By Grouping Name',
    GET_NEW_PAYMENT_TERMS: 'Get New Payment Terms',
    GET_AUTHORIZATION_FROM_DATA: 'Get Authorization From Data',
    GET_AUTHORIZATION_DATA: 'Get Authorization Data',
    GET_TAX_CODE: 'Get Tax code',
    MATOMO_TRACK_EVENT: 'Matomo track event',
    GET_ALL_INCOTERMS: 'Get all incoterms',
    NEW_SUBMIT_PR: 'New Submit PR',
    SEND_EMAIL: 'Send email',
    GET_CONSUMPTION_LEVEL: 'Get Consumption Level',
    SET_FILTER_TO_ALL: 'Set Filter To All',
    GET_PR_STATUS_FROM_BACKEND: 'Get PR status from backend',
    GET_CONDITION_TYPES: 'Get Condition Types',
    MASS_SUBMIT_PRS: 'Mass Submit PRs',
    GET_PSL_STATUS: 'Get PSL status',
    GET_CB_JUSTIFICATION_THRESHOLD_TOLER: 'Get CB Justification Threshold (TOLER)',
    GET_EPR_ID_FROM_TAG: 'Get EPR Id from tag',
    GET_PSL_REQUEST: 'Get PSL Request',
    GET_MATERIAL_TYPE: 'Get Material type',
    GET_L3_CATEGORY: 'Get L3 Category',
    CHECK_COMPANY_CODE: 'Check company code',
    MASS_DELETE_PRS: 'Mass Delete PRs',
    GET_SYSTEM_ALIAS: 'Get System Alias',
    MASS_COPY_PRS: 'Mass Copy PRs',
    GET_SUPPLIER_PURCHASE_ORG_LINK: 'Get Supplier - Purchase Org Link',
    GET_USERS_GRAPH_API: 'Get Users Graph API',
    GET_USERS_BY_EMAIL_GRAPH_API: 'Get Users by email Graph API',
    GET_USER_ID_GRAPH_API: 'Get User ID Graph API',
    OPEN_CANDEX: 'Open Candex',
    GET_TAX_AMOUNT_VERTEX: 'Get tax amount (Vertex)',
    GET_PUNCHOUT_CATALOGS: 'Get PunchOut catalogs',
    GET_PUNCHOUT_CATALOG_URL: 'Get PunchOut Catalog URL',
    GET_TAX_CODE_FROM_MATERIAL: 'Get Tax Code from Material',
    OG_ITEM_CODE_DESC: 'OG Item code/desc',
    ML_GET_L3_CATEGORY: 'ML Get L3 Category',
    OG_GET_ALL_L3_CATEGORIES: 'OG Get All L3 Categories',
    CHECK_IF_CANDEX_IS_ENABLED: 'Check if Candex is enabled',
    OLYMPE_DB_CREATE: 'Create data',
    OLYMPE_DB_READ: 'Read data',
    OLYMPE_DB_UPDATE: 'Update data',
    OLYMPE_DB_DELETE: 'Delete data',
    OLYMPE_DB_MASS_UPSERT: 'Upload Records',
    ENCRYPT: 'Encrypt Password',
    OPEN_NESTBUY_CATALOG: 'Open NestBuy Catalog',
    CHECK_IF_NESTBUY_CC_IS_ENABLED: 'Check if NestBuy CC is enabled',
};

export const getGroupedStatusLabel = (status) => {
    const normalizedStatus = status.toLowerCase();
    for (const group in STATUS_GROUPS) {
        if (STATUS_GROUPS.hasOwnProperty(group)) {
            const normalizedStatuses = STATUS_GROUPS[group].statuses.map((status) => status.toLowerCase());
            if (normalizedStatuses.includes(normalizedStatus)) {
                return STATUS_GROUPS[group].label;
            }
        }
    }

    return getStringValueForStatus(status);
};

export const getStringValueForStatus = (key) => {
    return STATUSES_TO_STRING_VALUE[key?.toLowerCase()] || 'Unknown';
};

export const getTooltipTitleForStatus = (key) => {
    return STATUSES_TO_TOOLTIP_TITLE[key?.toLowerCase()] || 'Unknown';
};

export const NO_OPTIONS_LABEL = 'No options';
export const NO_OPTIONS_ARRAY = [{label: NO_OPTIONS_LABEL, value: ''}];

export const getStringValueForSource = (key) => {
    // We need to check agency mania, tsf and psl for the old PR
    if (Object.keys(SOURCES_TO_STRING_VALUE).includes(key?.toLowerCase())) {
        return SOURCES_TO_STRING_VALUE[key?.toLowerCase()] || SOURCES_TO_STRING_VALUE.sourcingevent;
    }

    return `Sourcing Event (${key})`;
};

const DISPLAY_VALUE_TO_SOURCE_KEY = Object.fromEntries(
    Object.entries(SOURCES_TO_STRING_VALUE).map(([key, value]) => [value.toLowerCase(), key]),
);

const normalizeSourceKey = (key) => {
    if (!key) return key;
    const lowerKey = key.toLowerCase();
    if (SOURCES_TO_STRING_VALUE[lowerKey]) {
        return lowerKey;
    }

    const sourceKey = DISPLAY_VALUE_TO_SOURCE_KEY[lowerKey];
    return sourceKey || key;
};

export const getStringValueForSourceFromApiKey = (source, sourceFromApiKey) => {
    const sourceKey = normalizeSourceKey(source);
    const sourceFromApiKeyKey = normalizeSourceKey(sourceFromApiKey);

    if (sourceKey === sourceFromApiKeyKey || !sourceFromApiKeyKey) {
        return getStringValueForSource(sourceKey);
    } else {
        const getSourceStringWithoutSourcingEvent = (key) => {
            const value = SOURCES_TO_STRING_VALUE[key?.toLowerCase()];
            if (value) {
                return value.replace(/Sourcing Event \(|\)/g, '').trim();
            }
            return key;
        };

        const sourceString = getSourceStringWithoutSourcingEvent(sourceKey);
        const sourceFromApiKeyString = getSourceStringWithoutSourcingEvent(sourceFromApiKeyKey);

        return `${sourceFromApiKeyString} / ${sourceString}`;
    }
};

export const filterIncludeColor = '#9AEEB1';
export const filterExcludeColor = '#F996A6';

export const FILE_TAG = 'ff021000000000000031';

export const companyCodesToSkipApprovals = ['LK12'];
export const skipApprovalsForCompanyCodes = (value) => {
    return companyCodesToSkipApprovals.includes(value);
};

export const SUBMISSION_STATUS = {
    '1_validating': 'Validating the PR...',
    '2_approval': 'Checking for SB and OB validation...',
    '3_submitting': 'Submitting PR and attachment to SAP...',
    '4_saving': 'Saving SAP PR Number...',
    '5_moving': 'Moving PR to "Submitted Requests"...',
    '6_finishing': 'Finishing...',
};

export const companyCodesEnablePOSendingOptions = {
    codev: ['AO12', 'AO13', 'BD10', 'BE12', 'BE14', 'BE31', 'BF10', 'BO10', 'CH0P', 'CH0T', 'CH0W', 'CH0X', 'CH0Z', 'CH11', 'CH12', 'CH17', 'CH1A', 'CH20', 'CH27', 'CH30', 'CH82', 'CH85', 'CH99', 'CI11', 'CI14', 'CL10', 'CL11', 'CM10', 'CO11', 'CO13', 'CO16', 'CO17', 'CO18', 'CR10', 'CZ11', 'CZ16', 'DE0K', 'DE10', 'DE13', 'DE21', 'DE2A', 'DE2I', 'DE2N', 'DE52', 'DE55', 'DE60', 'DE64', 'DE66', 'DK12', 'DO12', 'ES10', 'ES21', 'ES42', 'FI11', 'FR0W', 'FR0Y', 'FR10', 'FR12', 'FR13', 'FR15', 'FR1A', 'FR20', 'FR29', 'FR41', 'FR42', 'FR45', 'FR46', 'FR47', 'FR49', 'FR54', 'FR57', 'FR58', 'FR65', 'FR66', 'FR78', 'FR80', 'FR97', 'GA10', 'GB11', 'GB12', 'GB19', 'GB21', 'GB23', 'GB95', 'GH10', 'GH11', 'GR10', 'GR18', 'GT10', 'GT12', 'GT13', 'GT18', 'HN10', 'HR14', 'ID10', 'ID16', 'ID18', 'IE10', 'IE24', 'IL11', 'IL14', 'IL16', 'IL20', 'IL23', 'IL33', 'IT11', 'IT15', 'IT38', 'IT39', 'JP21', 'MA10', 'MA12', 'MM10', 'MM11', 'MX32', 'MY33', 'MY34', 'MY36', 'MY37', 'MY38', 'MY39', 'MY40', 'MY42', 'NG10', 'NI10', 'NL10', 'NO10', 'PA12', 'PA19', 'PA20', 'PA26', 'PA71', 'PE10', 'PE15', 'PH11', 'PH15', 'PH24', 'PH26', 'PH27', 'PK10', 'PL10', 'PL16', 'PL33', 'PT10', 'PT24', 'SE16', 'SG12', 'SG23', 'SG27', 'SG28', 'SK10', 'SN10', 'SV10', 'TH10', 'TH11', 'TH12', 'TH13', 'TH14', 'TH15', 'TH16', 'TH17', 'TH18', 'TH19', 'TH20', 'TH21', 'TH22', 'TH23', 'TH24', 'TR10', 'TR13', 'TR17', 'UA10', 'UA11', 'UA12', 'UA14', 'UA15', 'US0X', 'US8X', 'ZA10', 'DO12', 'JM11', 'PA17', 'TT10', 'MX10', 'MX13', 'MX14', 'MX18', 'MX19', 'MX20', 'MX21', 'MX23', 'MX27', 'MX29', 'MX30', 'MX38', 'CH30', 'IT43', 'PH11', 'PH15', 'PH24', 'PH26', 'PH27', 'SK10', 'LT12', 'PL10', 'PL16', 'PL33', 'CZ11', 'CZ16', 'HU10', 'HU17', 'BG10', 'RO10', 'BA10', 'RS10', 'SI11', 'HR14', 'MK10', 'EC12', 'EC13', 'EC14', 'KR25', 'CA10', 'AT10', 'Z200', 'AE10', 'AE12', 'AE17', 'AE18', 'EG10', 'DZ12', 'DZ11', 'BH11', 'JO11', 'KW10', 'LB12', 'OM10', 'PS10', 'QA11', 'SA17', 'SA11', 'SY10', 'MU14', 'KE12', 'ZW11', 'AU11', 'NC10', 'FJ10', 'PG10', 'PF10', 'NZ11', 'IN12', 'IN14', 'IN15', 'IN16', 'MT10', 'VE26', 'VE27', 'CN27', 'CN28', 'CN4R', 'CN35', 'CN58', 'SA21', 'USNQ'],
    preprod: ['AO12', 'AO13', 'BD10', 'BE12', 'BE14', 'BE31', 'BF10', 'BO10', 'CH0P', 'CH0T', 'CH0W', 'CH0X', 'CH0Z', 'CH11', 'CH12', 'CH17', 'CH1A', 'CH20', 'CH27', 'CH30', 'CH82', 'CH85', 'CH99', 'CI11', 'CI14', 'CL10', 'CL11', 'CM10', 'CO11', 'CO13', 'CO16', 'CO17', 'CO18', 'CR10', 'CZ11', 'CZ16', 'DE0K', 'DE10', 'DE13', 'DE21', 'DE2A', 'DE2I', 'DE2N', 'DE52', 'DE55', 'DE60', 'DE64', 'DE66', 'DK12', 'DO12', 'ES10', 'ES21', 'ES42', 'FI11', 'FR0W', 'FR0Y', 'FR10', 'FR12', 'FR13', 'FR15', 'FR1A', 'FR20', 'FR29', 'FR41', 'FR42', 'FR45', 'FR46', 'FR47', 'FR49', 'FR54', 'FR57', 'FR58', 'FR65', 'FR66', 'FR78', 'FR80', 'FR97', 'GA10', 'GB11', 'GB12', 'GB19', 'GB21', 'GB23', 'GB95', 'GH10', 'GH11', 'GR10', 'GR18', 'GT10', 'GT12', 'GT13', 'GT18', 'HN10', 'HR14', 'ID10', 'ID16', 'ID18', 'IE10', 'IE24', 'IL11', 'IL14', 'IL16', 'IL20', 'IL23', 'IL33', 'IT11', 'IT15', 'IT38', 'IT39', 'JP21', 'MA10', 'MA12', 'MM10', 'MM11', 'MX32', 'MY33', 'MY34', 'MY36', 'MY37', 'MY38', 'MY39', 'MY40', 'MY42', 'NG10', 'NI10', 'NL10', 'NO10', 'PA12', 'PA19', 'PA20', 'PA26', 'PA71', 'PE10', 'PE15', 'PH11', 'PH15', 'PH24', 'PH26', 'PH27', 'PK10', 'PL10', 'PL16', 'PL33', 'PT10', 'PT24', 'SE16', 'SG12', 'SG23', 'SG27', 'SG28', 'SK10', 'SN10', 'SV10', 'TH10', 'TH11', 'TH12', 'TH13', 'TH14', 'TH15', 'TH16', 'TH17', 'TH18', 'TH19', 'TH20', 'TH21', 'TH22', 'TH23', 'TH24', 'TR10', 'TR13', 'TR17', 'UA10', 'UA11', 'UA12', 'UA14', 'UA15', 'US0X', 'US8X', 'ZA10', 'DO12', 'JM11', 'PA17', 'TT10', 'MX10', 'MX13', 'MX14', 'MX18', 'MX19', 'MX20', 'MX21', 'MX23', 'MX27', 'MX29', 'MX30', 'MX38', 'CH30', 'IT43', 'PH11', 'PH15', 'PH24', 'PH26', 'PH27', 'SK10', 'LT12', 'PL10', 'PL16', 'PL33', 'CZ11', 'CZ16', 'HU10', 'HU17', 'BG10', 'RO10', 'BA10', 'RS10', 'SI11', 'HR14', 'MK10', 'EC12', 'EC13', 'EC14', 'KR25', 'CA10', 'AT10', 'Z200', 'AE10', 'AE12', 'AE17', 'AE18', 'EG10', 'DZ12', 'DZ11', 'BH11', 'JO11', 'KW10', 'LB12', 'OM10', 'PS10', 'QA11', 'SA17', 'SA11', 'SY10', 'MU14', 'KE12', 'ZW11', 'AU11', 'NC10', 'FJ10', 'PG10', 'PF10', 'NZ11', 'IN12', 'IN14', 'IN15', 'IN16', 'MT10', 'VE26', 'VE27', 'MD10', 'US9A', 'US5C', 'US5Z', 'US9B', 'ZA23', 'VN10', 'SA20', 'CA23', 'US39', 'US16', 'PA72', 'BG15', 'FR1U', 'GB0M', 'HR11', 'SA21', 'USNQ', 'GT25', 'US8W', 'CA33', 'CL26', 'PE18', 'ES49', 'HK15', 'CA34', 'CN37', 'TW10','CH9U','CN10','CN17','CN36','ZW13','TH28','MY48','MY49', 'TT13'],
    prod: ['AO12', 'AO13', 'BD10', 'BE12', 'BE14', 'BE31', 'BF10', 'BO10', 'CH0P', 'CH0T', 'CH0W', 'CH0X', 'CH0Z', 'CH11', 'CH12', 'CH17', 'CH1A', 'CH20', 'CH27', 'CH30', 'CH82', 'CH85', 'CH99', 'CI11', 'CI14', 'CL10', 'CL11', 'CM10', 'CO11', 'CO13', 'CO16', 'CO17', 'CO18', 'CR10', 'CZ11', 'CZ16', 'DE0K', 'DE10', 'DE13', 'DE21', 'DE2A', 'DE2I', 'DE2N', 'DE52', 'DE55', 'DE60', 'DE64', 'DE66', 'DK12', 'DO12', 'ES10', 'ES21', 'ES42', 'FI11', 'FR0W', 'FR0Y', 'FR10', 'FR12', 'FR13', 'FR15', 'FR1A', 'FR20', 'FR29', 'FR41', 'FR42', 'FR45', 'FR46', 'FR47', 'FR49', 'FR54', 'FR57', 'FR58', 'FR65', 'FR66', 'FR78', 'FR80', 'FR97', 'GA10', 'GB11', 'GB12', 'GB19', 'GB21', 'GB23', 'GB95', 'GH10', 'GH11', 'GR10', 'GR18', 'GT10', 'GT12', 'GT13', 'GT18', 'HN10', 'HR14', 'ID10', 'ID16', 'ID18', 'IE10', 'IE24', 'IL11', 'IL14', 'IL16', 'IL20', 'IL23', 'IL33', 'IT11', 'IT15', 'IT38', 'IT39', 'JP21', 'MA10', 'MA12', 'MM10', 'MM11', 'MX32', 'MY33', 'MY34', 'MY36', 'MY37', 'MY38', 'MY39', 'MY40', 'MY42', 'NG10', 'NI10', 'NL10', 'NO10', 'PA12', 'PA19', 'PA20', 'PA26', 'PA71', 'PE10', 'PE15', 'PH11', 'PH15', 'PH24', 'PH26', 'PH27', 'PK10', 'PL10', 'PL16', 'PL33', 'PT10', 'PT24', 'SE16', 'SG12', 'SG23', 'SG27', 'SG28', 'SK10', 'SN10', 'SV10', 'TH10', 'TH11', 'TH12', 'TH13', 'TH14', 'TH15', 'TH16', 'TH17', 'TH18', 'TH19', 'TH20', 'TH21', 'TH22', 'TH23', 'TH24', 'TR10', 'TR13', 'TR17', 'UA10', 'UA11', 'UA12', 'UA14', 'UA15', 'US0X', 'US8X', 'ZA10', 'DO12', 'JM11', 'PA17', 'TT10', 'MX10', 'MX13', 'MX14', 'MX18', 'MX19', 'MX20', 'MX21', 'MX23', 'MX27', 'MX29', 'MX30', 'MX38', 'CH30', 'IT43', 'AR12', 'AR14', 'AR15', 'AR18', 'AR20', 'AR22', 'AR25', 'PY12', 'PY13', 'PY14', 'UY10', 'UY13', 'AE10', 'AE12', 'AE17', 'AE18', 'EG10', 'DZ12', 'DZ11', 'BH11', 'JO11', 'KW10', 'LB12', 'OM10', 'PS10', 'QA11', 'SA17', 'SA11', 'SY10', 'PH11', 'PH15', 'PH24', 'PH26', 'PH27', 'SK10', 'LT12', 'PL10', 'PL16', 'PL33', 'CZ11', 'CZ16', 'HU10', 'HU17', 'BG10', 'RO10', 'BA10', 'RS10', 'SI11', 'HR14', 'MK10', 'EC12', 'EC13', 'EC14', 'KR25', 'CA10', 'AT10', 'MU14', 'KE12', 'ZW11', 'AU11', 'NZ11', 'IN12', 'IN14', 'IN15', 'IN16', 'NC10', 'FJ10', 'PG10', 'PF10', 'MT10', 'VE26', 'VE27', 'MD10', 'US9A', 'US5C', 'US5Z', 'US9B', 'FR1P', 'FR1G', 'MD10', 'FR1R', 'IT44', 'US0E', 'US0L', 'US10', 'US16', 'US22', 'US5C', 'US5Z', 'US8X', 'US9A', 'US9B', 'US1I', 'ZA23', 'CA31', 'SA20', 'US39', 'CA23', 'BG15', 'ZW12', 'PA72', 'GB0M', 'FR1U', 'SA21', 'FR14', 'MY43', 'GT25', 'USNQ', 'PE18', 'CL26', 'CA34', 'HK01', 'HK10', 'HK16', 'HK17', 'HK18', 'HK19', 'HK21', 'HK22', 'HK23', 'HK25', 'HK28', 'HK15', 'CN37', 'TW10', 'CH9U', 'TT13'],
};

export const MAX_LENGTH_OF_MATERIAL_NAME_AND_MATERIAL_DESC = 40;

export const supplierCodesForEnablingBlankAccountType = {
    codev: ['0100004688', '0101171164', '0101298303', '0100004689', '0101291796', '0100884263', '0101171165', '0101171269', '0101079892', '0100922479', '0100461371', '0101235134', '0100220326', '0100548031', '0100364916', '0100001758', '0100002698', '0100209047', '0100606709', '0100959256', '0101243618', '0101257360', '0101010189', '0101232252', '0101247176', '0101234075', '0100520079', '0100452569', '0101034576', '0100364648', '0100117792', '0100098326', '0100002462', '0100748845', '0100994532', '0100220242', '0101195158', '0100154561', '0100613054', '0100763506', '0100814918', '0100218023', '0100139033', '0101013140', '0100117181', '0100754681'],
    preprod: ['0100004688', '0101171164', '0101298303', '0100004689', '0101291796', '0100884263', '0101171165', '0101171269', '0101079892', '0100922479', '0100461371', '0101235134', '0100220326', '0100548031', '0100364916', '0100001758', '0100002698', '0100209047', '0100606709', '0100959256', '0101243618', '0101257360', '0101010189', '0101232252', '0101247176', '0101234075', '0100520079', '0100452569', '0101034576', '0100364648', '0100117792', '0100098326', '0100002462', '0100748845', '0100994532', '0100220242', '0101195158', '0100154561', '0100613054', '0100763506', '0100814918', '0100218023', '0100139033', '0101013140', '0100117181', '0101267668', '0101475310', '0101053345', '0100012879', '0100911768', '0100754681'],
    prod: ['0100004688', '0101171164', '0101298303', '0100004689', '0101291796', '0100884263', '0101171165', '0101171269', '0101079892', '0100922479', '0100461371', '0101235134', '0100220326', '0100548031', '0100364916', '0100001758', '0100002698', '0100209047', '0100606709', '0100959256', '0101243618', '0101257360', '0101010189', '0101232252', '0101247176', '0101234075', '0100520079', '0100452569', '0101034576', '0100364648', '0100117792', '0100098326', '0100002462', '0100748845', '0100994532', '0100220242', '0101195158', '0100154561', '0100613054', '0100763506', '0100814918', '0100218023', '0100139033', '0101013140', '0100754681', '0100725618', '0101349087', '0101020689', '0101313733'],
};

export const purchasingGroupCodesForEnablingBlankAccountType = {
    codev: ['O68', 'NI2', 'L2P', 'LRX', 'AB9', 'ZI4', 'LRX', 'UZ4', 'B2U', 'LRX', '09A', 'IMS', 'B1F', 'HO9', 'GN3', 'LUZ', 'LIA', 'LGK', 'LGZ', 'GS6', '09A', 'LRX', 'S07', 'LAQ', 'LKO', 'EH1', 'LGK', '7SE', 'F29', 'FHC', 'ZIS', 'HP9', 'GF1', 'GF1', 'LGK', 'LGZ', 'LGK', 'LGZ', 'D65', 'K33', 'IC1', 'IN1', '1P6', 'V14', 'LRV', 'IMS', 'Z092', 'EA8', 'UZ4', 'LE2', 'HR10', 'MH8', 'IMS', 'MT1', 'NM2', 'M65', 'UZ4', 'NO9', 'NTA', 'AD7', 'LGK', 'GK1', 'EH1', 'PA1', 'LGK', 'L4A', 'LZJ', '460', 'N99', 'N20', '17E', 'UZ4', 'RB9', 'D85', 'EH1', 'SJ0', 'EH5', 'GX2', '09A', 'SD2', 'SD2', 'S07', 'S24', '701', '11P', '7SE', '032', 'C76', 'T48', 'LAD', 'O21', 'U89', 'UC4', 'A19', 'IMS', 'L50', 'EH1', 'VQ2', 'G7Q'],
    preprod: ['O68', 'NI2', 'L2P', 'LRX', 'AB9', 'ZI4', 'LRX', 'UZ4', 'B2U', 'LRX', '09A', 'IMS', 'B1F', 'HO9', 'GN3', 'LUZ', 'LIA', 'LGK', 'LGZ', 'GS6', '09A', 'LRX', 'S07', 'LAQ', 'LKO', 'EH1', 'LGK', '7SE', 'F29', 'FHC', 'ZIS', 'HP9', 'GF1', 'GF1', 'LGK', 'LGZ', 'LGK', 'LGZ', 'D65', 'K33', 'IC1', 'IN1', '1P6', 'V14', 'LRV', 'IMS', 'Z092', 'EA8', 'UZ4', 'LE2', 'HR10', 'MH8', 'IMS', 'MT1', 'NM2', 'M65', 'UZ4', 'NO9', 'NTA', 'AD7', 'LGK', 'GK1', 'EH1', 'PA1', 'LGK', 'L4A', 'LZJ', '460', 'N99', 'N20', '17E', 'UZ4', 'RB9', 'D85', 'EH1', 'SJ0', 'EH5', 'GX2', '09A', 'SD2', 'SD2', 'S07', 'S24', '701', '11P', '7SE', '032', 'C76', 'T48', 'LAD', 'O21', 'U89', 'UC4', 'A19', 'IMS', 'L50', 'EH1', 'VQ2', 'G7Q'],
    prod: ['O68', 'NI2', 'L2P', 'LRX', 'AB9', 'ZI4', 'LRX', 'UZ4', 'B2U', 'LRX', '09A', 'IMS', 'B1F', 'HO9', 'GN3', 'LUZ', 'LIA', 'LGK', 'LGZ', 'GS6', '09A', 'LRX', 'S07', 'LAQ', 'LKO', 'EH1', 'LGK', '7SE', 'F29', 'FHC', 'ZIS', 'HP9', 'GF1', 'GF1', 'LGK', 'LGZ', 'LGK', 'LGZ', 'D65', 'K33', 'IC1', 'IN1', '1P6', 'V14', 'LRV', 'IMS', 'Z092', 'EA8', 'UZ4', 'LE2', 'HR10', 'MH8', 'IMS', 'MT1', 'NM2', 'M65', 'UZ4', 'NO9', 'NTA', 'AD7', 'LGK', 'GK1', 'EH1', 'PA1', 'LGK', 'L4A', 'LZJ', '460', 'N99', 'N20', '17E', 'UZ4', 'RB9', 'D85', 'EH1', 'SJ0', 'EH5', 'GX2', '09A', 'SD2', 'SD2', 'S07', 'S24', '701', '11P', '7SE', '032', 'C76', 'T48', 'LAD', 'O21', 'U89', 'UC4', 'A19', 'IMS', 'L50', 'EH1', 'VQ2', 'G7Q', 'LBV', 'LZJ', 'LMP'],
};

export const plantCodesForEnablingBlankAccountType = {
    codev: ['6393', '9685', '0430', '2974', '1708', 'D616', '0557', '2974', '3824', '0188', '2974', '3733', '1202', '0456', '4860', '1494', '0076', '0466', '2444', '1468', '1939', '2974', '0356', '3310', '1100', '0686', '0696', '2704', '1403', '4799', '0710', '1484', '9855', '3935', '2444', '2899', '1099', '0972', '0232', '0196', '0248', '3621', '7535', '0647', '6600', '2367', '3827', 'AE13', 'AE14', 'B007', '3829', '3851', '9912', 'MK10', '9523', '9495', 'B321', 'B005', '4005', '0325', '1776', '2891', '1719', '2903', '1476', '1402', '3825', '1583', '2700', '8773', '0110', '0245', '0339', '3538', '3823', '2747', '4876', '6505', '1491', '6839', '9526', '9518', '0369', '0993', '3537', '3641', '7085', '0132', '3830', '1119', '2711', '2972', '2675', '0199', '1938', '2694', '0247', '8775', '0618', '4285', '0214', '9855'],
    preprod: ['6393', '9685', '0430', '2974', '1708', 'D616', '0557', '2974', '3824', '0188', '2974', '3733', '1202', '0456', '4860', '1494', '0076', '0466', '2444', '1468', '1939', '2974', '0356', '3310', '1100', '0686', '0696', '2704', '1403', '4799', '0710', '1484', '9855', '3935', '2444', '2899', '1099', '0972', '0232', '0196', '0248', '3621', '7535', '0647', '6600', '2367', '3827', 'AE13', 'AE14', 'B007', '3829', '3851', '9912', 'MK10', '9523', '9495', 'B321', 'B005', '4005', '0325', '1776', '2891', '1719', '2903', '1476', '1402', '3825', '1583', '2700', '8773', '0110', '0245', '0339', '3538', '3823', '2747', '4876', '6505', '1491', '6839', '9526', '9518', '0369', '0993', '3537', '3641', '7085', '0132', '3830', '1119', '2711', '2972', '2675', '0199', '1938', '2694', '0247', '8775', '0618', '4285', '0214', '0292', 'W004', '4047', '4729', '9855'],
    prod: ['6393', '9685', '0430', '2974', '1708', 'D616', '0557', '2974', '3824', '0188', '2974', '3733', '1202', '0456', '4860', '1494', '0076', '0466', '2444', '1468', '1939', '2974', '0356', '3310', '1100', '0686', '0696', '2704', '1403', '4799', '0710', '1484', '9855', '3935', '2444', '2899', '1099', '0972', '0232', '0196', '0248', '3621', '7535', '0647', '6600', '2367', '3827', 'AE13', 'AE14', 'B007', '3829', '3851', '9912', 'MK10', '9523', '9495', 'B321', 'B005', '4005', '0325', '1776', '2891', '1719', '2903', '1476', '1402', '3825', '1583', '2700', '8773', '0110', '0245', '0339', '3538', '3823', '2747', '4876', '6505', '1491', '6839', '9526', '9518', '0369', '0993', '3537', '3641', '7085', '0132', '3830', '1119', '2711', '2972', '2675', '0199', '1938', '2694', '0247', '8775', '0618', '4285', '9855', '0076', '0107', 'B573'],
};

export const materialTypesForEnablingBlankAccountType = [
    'ZTAS',
    'FERT',
];

export const companyCodesEnablingUnknownAccountType = {
    codev: ['CA10'],
    preprod: ['CA10'],
    prod: ['CA10'],
};

export const purchasingGrpEnablingUnknownAccountType = {
    codev: ['117', '124', '156', '214', '187'],
    preprod: ['117', '124', '156', '214', '187'],
    prod: ['117', '124', '156', '214', '187'],
};

export const supplierStatusPriorities = new Map([
    ['Mandatory', 4],
    ['SoleSource', 3],
    ['Validated', 2],
    ['Blank', 1],
    ['', 1],
]);

export const invertedSupplierStatusPriorities = new Map([
    [4, 'Mandatory'],
    [3, 'SoleSource'],
    [2, 'Validated'],
    [1, 'Blank'],
]);

export const mandatoryFieldsForSpender = [
    'Spender',
    'Company code',
    'Business Unit',
    'Purchase organization',
    'Default plant',
    'Default delivery address',
    'Default requested delivery date',
    'Validity start',
    'Validity end',
    'Material code',
    'Material description',
    'Quantity',
    'Unit',
    'Price',
    'Currency',
    'Per',
    'Requested delivery date',
    'Plant',
    'Delivery address',
    'Account type',
    'Cost center',
    'WBS',
    'Profit center',
    'GL account',
    'Supplier',
];

export const mandatoryFieldsForRequester = [
    'Way of Buying',
    'Requester',
    'Purchasing group',
    'Ordering address',
    'Invoice partner',
    'Tax code',
];

/**
 * This is the maximum size of a file that users can upload, according to the environment. This is in MB
 * @type {Map<string, number>}
 */
export const MAX_FILE_SIZE= new Map([
    ['codev', 50],
    ['preprod', 50],
    ['prod', 60],
]);

// used to be able to submit in prod
export const SUPER_USERS_LIST = ['JDUBEY', 'JMULLER1', 'NBBALASODI', 'NBKARPAD'];

export const ADMIN_APP_TABLE_NAMES = {
    'sb_group': 'SB - Groups',
    'strategic_buyer_commodity': 'SB - Commodity code',
    'strategic_buyer_supplier': 'SB - Supplier',
    'company_code_disabling_dyn': 'DYN disabled by ComCode',
    'admin_app_user_list_mapping': 'Admin App User List',
};

export const ADMIN_APP_TABLE_COLUMNS = {
    'user_id': 'User Id',
    'name': 'Full name',
    'email': 'Email',
    'company_code': 'Company Code',
    'unique_name': 'Unique name',
    'maximum_1': 'Maximum',
    'maximum_1_currency': 'Currency',
    'minimum_1': 'Minimum',
    'minimumn_1_currency': 'Currency',
    'threshold_id_1': 'Threshold',
    'description': 'Description',
    'purchasing_unit': 'Purchasing Unit',
    'maximum_2': 'Maximum',
    'maximum_2_currency': 'Currency',
    'threshold_id_2': 'Threshold',
    'idx': 'ID',
    'grp_name': 'Group name',
    'commodity': 'Commodity',
    'total_cost': 'Total cost',
    'cus_psl_vendor_status': 'Vendor status',
    'user_mail': 'User email',
    'password_adapter': 'Password adapter',
    'grouping': 'Grouping',
    'tooltip': 'Tooltip',
    'required': 'Required',
    'supplier_id': 'Supplier code',
};

export const CMV_DEV = '0100136745';
export const OTV_DEV = '0100117437';
export const MTV_DEV = '0100000001';
export const CMV_PREPROD = '0100931989';
export const OTV_PREPROD = '0100013802';
export const MTV_PREPROD = '0101550708';
export const CMV_PROD = '0100799493';
export const OTV_PROD = '0100013802';
export const MTV_PROD = '0101550708';

export const TRANSPORT_OPTIONS_ENUM = {
    'Via Condition type': 3,
    'Via Material line - Supplier is different': 2,
    'Via Material line - Same supplier': 1,
    'No transport cost added': 0,
};

export const REQUEST_COCKPIT_LINK = {
    'codev': 'https://dev.s2pbrowser.nestle.com/document-flow',
    'preprod': 'https://test.s2pbrowser.nestle.com/document-flow',
    'prod': 'https://s2pbrowser.nestle.com/document-flow',
};


export const COLUMN_NAMES = {
    COMPANY_CODE: 'Company Code',
    EASY_REQUEST_PR_ID: 'Easy Request PR ID',
    SAP_PR_NUMBER: 'SAP PR Number',
    STATUS: 'Status',
    FROM: 'From',
    SPENDER: 'Spender',
    REQUESTER: 'Requester',
    CREATION_DATE: 'Creation Date',
    SUBMISSION_DATE: 'Submission Date',
    TITLE: 'Title',
    SUPPLIER: 'Supplier',
    CATEGORY: 'Category',
    MATERIAL: 'Material',
};

export const EMPTY_LABEL_VALUE = {
    label: '',
    value: '',
};

export const EMPTY_DELIVERY_ADDRESS = {
    name: '',
    name2: '',
    houseNumber: '',
    street: '',
    postalCode: '',
    city: '',
    state: '',
    country: '',
    manuallyModified: false,
};

export const excelHeaderFields = [
    {
        column: 'A',
        header: 'EPR Id',
        value: (prData, EPRId) => EPRId,
    },
    {
        column: 'B',
        header: 'Project title',
        value: (prData) => prData.projectTitle || '',
    },
    {
        column: 'C',
        header: 'Vendor code',
        value: (prData) => prData.vendorCode || '',
    },
    {
        column: 'D',
        header: 'OTV/CMV name',
        value: (prData) => prData.oneTimeVendor?.supplierName || '',
    },
    {
        column: 'E',
        header: 'OTV/CMV name 2',
        value: (prData) => prData.oneTimeVendor?.address?.name2 || '',
    },
    {
        column: 'F',
        header: 'House number',
        value: (prData) => prData.oneTimeVendor?.address?.houseNumber || '',
    },
    {
        column: 'G',
        header: 'Street',
        value: (prData) => prData.oneTimeVendor?.address?.street || '',
    },
    {
        column: 'H',
        header: 'Postal code',
        value: (prData) => prData.oneTimeVendor?.address?.postalCode || '',
    },
    {
        column: 'I',
        header: 'City',
        value: (prData) => prData.oneTimeVendor?.address?.city || '',
    },
    {
        column: 'J',
        header: 'State/Province/Area',
        value: (prData) => prData.oneTimeVendor?.address?.state || '',
    },
    {
        column: 'K',
        header: 'Country',
        value: (prData) => prData.oneTimeVendor?.address?.country || '',
    },
    {
        column: 'L',
        header: 'Phone number',
        value: (prData) => prData.oneTimeVendor?.phoneNumber || '',
    },
    {
        column: 'M',
        header: 'Way of buying',
        value: (prData) => prData.wayOfBuying?.currentValue?.label || '',
    },
    {
        column: 'N',
        header: 'Spender',
        value: (prData) => prData.spender?.value || '',
    },
    {
        column: 'O',
        header: 'Requester',
        value: (prData) => prData.requester?.value || '',
    },
    {
        column: 'P',
        header: 'Company code',
        value: (prData) => prData.headerDetails?.companyCode?.value || '',
    },
    {
        column: 'Q',
        header: 'Purchase organization',
        value: (prData) => prData.headerDetails?.purchaseOrganization?.value || '',
    },
    {
        column: 'R',
        header: 'Purchasing group',
        value: (prData) => prData.headerDetails?.purchasingGroup?.value || '',
    },
    {
        column: 'S',
        header: 'Validity start (FO)',
        value: (prData) => {
            const dateStr = prData.headerDetails?.validityStart || '';
            const date = parseDateString(dateStr);
            return date && isValid(date) ? format(date, 'dd-MMM-yy') : '';
        },
    },
    {
        column: 'T',
        header: 'Validity end (FO)',
        value: (prData) => {
            const dateStr = prData.headerDetails?.validityEnd || '';
            const date = parseDateString(dateStr);
            return date && isValid(date) ? format(date, 'dd-MMM-yy') : '';
        },
    },
    {
        column: 'U',
        header: 'Alternative payment terms',
        value: (prData) => prData.headerDetails?.newPaymentTerms?.value || '',
    },
    {
        column: 'V',
        header: 'Incoterms',
        value: (prData) => prData.headerDetails?.incoterms?.data?.value || '',
    },
    {
        column: 'W',
        header: 'Incoterms 2',
        value: (prData) => prData.headerDetails?.incoterms?.data?.label || '',
    },
    {
        column: 'X',
        header: 'Ordering address',
        value: (prData) => prData.headerDetails?.orderingAddress?.label || '',
    },
    {
        column: 'Y',
        header: 'Invoice Partner',
        value: (prData) => prData.headerDetails?.invoicePartner?.label || '',
    },
    {
        column: 'Z',
        header: 'Good Receipt Required',
        value: (prData) => prData.headerDetails?.goodsReceipt === true ? 'Yes' : 'No',
    },
    {
        column: 'AA',
        header: 'GR-Based Invoice Verification',
        value: (prData) => prData.headerDetails?.grBasedInvoiceVerification === true ? 'Yes' : 'No',
    },
    {
        column: 'AB',
        header: 'ERS',
        value: (prData) => prData.headerDetails?.ers === true ? 'Yes' : 'No',
    },
    {
        column: 'AC',
        header: 'Internal comment (headers)',
        value: (prData) => prData.internalComment || '',
    },
    {
        column: 'AD',
        header: 'External comment (headers)',
        value: (prData) => prData.externalComment || '',
    },
    {
        column: 'AE',
        header: 'Send PO PDF to requester',
        value: (prData) => prData.sendingOptions?.requester === true ? 'Yes' : 'No',
    },
    {
        column: 'AF',
        header: 'Send PO PDF to spender',
        value: (prData) => prData.sendingOptions?.spender === true ? 'Yes' : 'No',
    },
    {
        column: 'AG',
        header: 'Send PO PDF to other',
        value: (prData) => prData.sendingOptions?.other === true ? 'Yes' : 'No',
    },
    {
        column: 'AH',
        header: 'Other\'s address',
        value: (prData) => prData.sendingOptions?.otherAddress || '',
    },
    {
        column: 'AI',
        header: 'Send PO PDF to supplier',
        value: (prData) => prData.sendingOptions?.supplier === true ? 'Yes' : 'No',
    },
    {
        column: 'AJ',
        header: 'Supplier address',
        value: (prData) => prData.sendingOptions?.supplierAddresses?.join(';') || '',
    },
    {
        column: 'AK',
        header: 'Hide Price',
        value: (prData) => prData.sendingOptions?.hidePrice === true ? 'Yes' : 'No',
    },
    {
        column: 'AL',
        header: 'Vendor name',
        value: (prData) => prData.vendorName || '',
    },
    {
        column: 'AM',
        header: 'Plant',
        value: (prData) => prData.headerDetails?.defaultPlant?.value || '',
    },
    {
        column: 'AN',
        header: 'Storage Location',
        value: (prData) => prData.headerDetails?.defaultStorageLocation?.value || '',
    },
    {
        column: 'AO',
        header: 'Requested delivery date',
        value: (prData) => {
            const dateStr = prData.headerDetails?.defaultRequestedDeliveryDate || '';
            const date = parseDateString(dateStr);
            return date && isValid(date) ? format(date, 'dd-MMM-yy') : '';
        },
        format: 'dd-mmm-yy',
    },
    {
        column: 'AP',
        header: 'Initiated From',
        value: (prData) => prData.sourceFromApiKey || prData.source || '',
    },
    {
        column: 'AQ',
        header: 'Creation Date and Time',
        value: (prData) => {
            const dateStr = prData.creationDate || '';
            const date = parseDateString(dateStr);
            return date && isValid(date) ? format(date, 'dd-MMM-yy') : '';
        },
    },
    {
        column: 'AR',
        header: 'Submission Date',
        value: (prData) => {
            const dateStr = prData.submissionDate || '';
            const date = parseDateString(dateStr);
            return date && isValid(date) ? format(date, 'dd-MMM-yy') : '';
        },
    },
    {
        column: 'AS',
        header: 'PSL ID',
        value: (prData) => '',
    },
    {
        column: 'AT',
        header: 'Strategic Buyers',
        value: (prData, EPRId, excelFileName) => {
            if (excelFileName === 'submitted requests') {
                return prData.sbValidation?.sbApprover || '';
            } else {
                const strategicBuyers = prData.sbValidation?.strategicBuyers || [];
                return strategicBuyers.map((buyer) => buyer.email).join('; ') || '';
            }
        },
    },
    {
        column: 'AU',
        header: 'Compliance indicator',
        value: (prData) => prData.attachmentsInfo.complianceIndicator || '',
    },
    {
        column: 'AV',
        header: 'System Alias',
        value: (prData) => prData.systemAlias || '',
    },
    {
        column: 'AW',
        header: 'SAP PR number',
        value: (prData) => prData.prNumber || '',
    },
    {
        column: 'AX',
        header: 'Sourcing event ID',
        value: (prData) => prData.sourcingEventID || '',
    },
    {
        column: 'AY',
        header: 'Contract ID',
        value: (prData) => prData.contractID || '',
    },
    {
        column: 'AZ',
        header: 'Attachment topic (optional)',
        value: (prData) => {
            const res = [];
            const tmpAttachmentsTopics = prData.attachmentsInfo?.mainAttachments?.map((att) => att.topic) || [];
            if ( tmpAttachmentsTopics.length > 0 ) {
                res.push('Yes (' + tmpAttachmentsTopics.join(',') + ')');
            } else {
                res.push('No');
            }
            return res;
        },
    },
    {
        column: 'BA',
        header: 'Attachment topic (Competitive bidding justification)',
        value: (prData) => {
            const res = [];
            const tmpAttachmentsTopics = prData.attachmentsInfo?.competitiveBiddingJustificationAttachments?.map((att) => att.topic) || [];
            if ( tmpAttachmentsTopics.length > 0 ) {
                res.push('Yes (' + tmpAttachmentsTopics.join(',') + ')');
            } else {
                res.push('No');
            }
            return res;
        },
    },
    {
        column: 'BB',
        header: 'Exception Reason',
        value: (prData) => prData.attachmentsInfo?.selectedException || '',
    },
];

export const NON_PSL_JUSTIFICATIONS = [
    'Best Price',
    'Best Material or Quality',
    'Best Lead times',
];

export const EMPTY_MATERIAL_NUMBER = 'EMPTY00';
